import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {Router, ActivatedRoute} from '@angular/router';
import {_AuthenticationService} from '../../services/auth.service';
import {_UserService} from '../../services/user.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [_AuthenticationService, _UserService]
})

export class LoginPage implements OnInit {
  model: any = {};
loading = false;
error = '';
redirectUrl: string;
result: any;

constructor(private router: Router,
            private activatedRoute: ActivatedRoute,
            private titleService: Title,
            private authenticationService: _AuthenticationService,
            private userService: _UserService) {
  this.redirectUrl = this.activatedRoute.snapshot.queryParams['redirectTo'];
}

  ngOnInit(){

    //Set the page title
    this.titleService.setTitle("WiseRisk | Login");

  }
  login() {
  this.loading = true;

  this.result = this.authenticationService.login(this.model.username, this.model.password)
  .subscribe((res)=>{
    this.userService.login(true);
    this.navigateAfterSuccess();
    this.error = null;
  }, (error) => {
    this.error = 'Username or password is incorrect';
  })
}

private navigateAfterSuccess() {
  if (this.redirectUrl) {
    this.router.navigateByUrl(this.redirectUrl);
  } else {
    this.router.navigate(['/exposure']);
  }
}
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/login/login.component.ts